import { render, staticRenderFns } from "./ProductManagerView.vue?vue&type=template&id=1ad4f48a&scoped=true"
import script from "./ProductManagerView.vue?vue&type=script&lang=js"
export * from "./ProductManagerView.vue?vue&type=script&lang=js"
import style0 from "./ProductManagerView.vue?vue&type=style&index=0&id=1ad4f48a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad4f48a",
  null
  
)

export default component.exports